export enum FeatureAccessLevelEnum {
  EDIT = "EDIT",
  VIEW_ONLY = "VIEW_ONLY",
  NONE = "NONE",
}

export enum FeaturesEnum {
  INCENTIVE_INDEX = "INCENTIVE_INDEX",
  RULE_ENGINE = "RULE_ENGINE",
  ESTIMATOR = "ESTIMATOR",
  PROJECT_DASHBOARD = "PROJECT_DASHBOARD",
  AUDIT = "AUDIT",
}
